import { InitiativeComment } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetInitiativeCommentsRequest = KeyPaginationQueryParams & {
	initiativeId: number;
};

export type GetInitiativeCommentsResponse = PaginatedResource<InitiativeComment>;

export const getInitiativeComments = createGetEndpoint<GetInitiativeCommentsRequest, GetInitiativeCommentsResponse>(
	({ initiativeId, ...rest }) =>
		`/api/v3/initiatives/${initiativeId}/comments?sortBy=addedOn&sortDirection=Ascending&${getQueryString(rest)}`
);
